import request from "@/utils/request";
// 获取智慧管理数据
export const bigScreeIHS = (data) =>
  request({
    headers: {
      "Content-Type": "application/json",
    },
    url: "/bigScreen/bigScreeIHS",
    method: "POST",
    data: data,
  });
